import { TableColumn } from './table-column';
import { Condition, TableOption, TableOptionCallback, TableSelectionCallback, VoidCallback } from './table-option';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FilterItem } from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { KeyValue } from '@angular/common';

export class TableDescriptor {
    headline = '';
    apiUrl: string;
    uniqueIdentifier: string;
    alternativeApiUrl: string;
    columns: TableColumn[] = [];

    permissionView: number;
    permissionCreate: number;
    searchPlaceholder = 'Suchen';
    initialSortColumn: string;
    initialSortDirection = 'asc';
    nameOfIdField = 'id';
    defaultPageSize = 10;
    pageSizeOptions: number[] = [5, 10, 20, 50, 100];
    route = '';
    detailsRoute: string;
    options: TableOption[] = [];
    params: HttpParams;
    filterParams: HttpParams;
    showDownloads = false;
    filterItems: FilterItem[] = [];
    standardCreate = true; // route .../neu
    createAllowed = true;
    showDetails = true;
    showDetailsExpandable = true;
    expandable = false;
    expandableFieldName: string;
    expandableColumns: TableColumn[] = [];
    /**
     * Lazy-Load für Expand-Zeilen: wird beim Aufklappen aufgerufen, wenn noch nicht geladen.
     * Soll `row[expandableFieldName]` setzen (Array). Sync, Promise oder Observable.
     */
    expandableLoad?: (row: any) => void | Promise<unknown> | Observable<unknown>;
    /** Zahlen-Spalten in der Expand-Tabelle unten summieren (z. B. `['kosten_netto']`). */
    expandableSumColumns: string[] = [];
    toolbarButtons: ToolbarButton[] = [];
    selectionToolbarButtons: SelectionToolbarButton[] = [];
    fileUploadApi: string;
    showSearchBar = true;
    clearSearch = false;
    waitToLoad = false;
    disableConditions: Condition[] = [];
    showDetailsVoid: TableOptionCallback;
    /** Wenn gesetzt: Zeile ist nur klickbar, wenn die Funktion `true` liefert (sonst kein Detail-Klick). */
    showDetailsForRow?: (row: any) => boolean;
    addVoid: VoidCallback;
    draggable = false;
    openFirstRows = 0;
    headlineColumnName: string;
    headlineColumnTitle: string;
    loadOnlyOnReload = false;
    selectable = false;
    showRefresh = true;
    sendCurrentClient = false;
    tooltips: string[] = [];

    totalRow = false;
    totalRowApiUrl: string;
    permissionDownload: number;
    clientSideSort = false;
    clientSideSearch = false;
    /** Skip 80px right padding used when row options column is sticky (table-specific layout). */
    skipOptionsTablePadding = false;
    /**
     * Keep column headers visible while the page scrolls normally.
     * Uses a floating header clone under the toolbar (no fixed table height).
     */
    stickyHeader = false;

    addToolbarButton(tb: ToolbarButton) {
        this.toolbarButtons.push(tb);
    }
}

export class ParamsChanged {
    params: HttpParams;
    uniqueIdentifier: string;

    constructor(uniqueIdentifier: string, params: HttpParams) {
        this.uniqueIdentifier = uniqueIdentifier;
        this.params = params;
    }
}

export class ExpandableRowClickedOptions {
    emit = false;
    navigate = true;
}

export class ToolbarButton {
    void: VoidCallback;
    icon: string;
    permission: number;
    tooltip: string;

    constructor(void_: VoidCallback, icon: string, permission: number, tooltip?: string) {
        this.void = void_;
        this.icon = icon;
        this.permission = permission;
        if (tooltip) {
            this.tooltip = tooltip;
        }
    }
}

export class SelectionToolbarButton {
    void: TableSelectionCallback;
    icon: string;
    permission: number;
    disableOnEmptySelection: boolean;
    tooltip: string;
    conditions: Condition[];

    constructor(
        void_: TableSelectionCallback,
        icon: string,
        permission: number,
        disableOnEmptySelection: boolean,
        tooltip?: string,
        conditions?: Condition[],
    ) {
        this.void = void_;
        this.icon = icon;
        this.permission = permission;
        this.disableOnEmptySelection = disableOnEmptySelection;
        if (tooltip) {
            this.tooltip = tooltip;
        }
        if (conditions) {
            this.conditions = conditions;
        }
    }

    checkConditions(dataList: any[]) {
        if (!this.conditions || this.conditions.length === 0) {
            return true;
        } else {
            for (const c of this.conditions) {
                for (const data of dataList) {
                    if (!c.check(data)) {
                        return false;
                    }
                }
            }
            return true;
        }
    }
}

export class KieneKeyValue implements KeyValue<string, any> {
    key: string;
    value: any;

    constructor(key: string, value: any) {
        this.key = key;
        this.value = value;
    }
}

export class SpalteKonfiguration {
    spalte: string;
    arrayKey: string;
    titel: string;
    sichtbar: number;
    aktiv: boolean;
}

export class SpaltenKonfigurationSendObject {
    tabelle: string;
    spalten: SpalteKonfiguration[] = [];
}
